import { useQuery } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";
import axios from "axios";

export const useGetSurveyScreenData = ({body: {report,caseId}, config}) => {
    //console.log("the scenario, ",report, caseId);
    return useQuery({
      queryKey: [QUERY_KEYS.SURVEYSCREEN, report,caseId],
      queryFn: () => {
        return axios
          .get(process.env.REACT_APP_API_URI+"FetchQuestions?report="+report+"&caseId="+caseId,config)
          .then((res) => {
          let result = res.data;
          if(result.error != null || result.error != undefined){
            throw new Error(result.message);
          }
          return result
          });
      },
      refetchOnWindowFocus: false,
    });
  }

  export const useGetReportQuestions = ({body: {report},config}) => {
    return useQuery({
      queryKey: [QUERY_KEYS.CONFIGURABLE, report],
      queryFn: () => {
        return axios
          .get(process.env.REACT_APP_API_URI+"FetchQuestions?report="+report, config)
          .then((res) => {
          let result = res.data;
          console.log("result is",result, "error is", result.error);
          if(result.error != null || result.error != undefined){
            throw new Error(result.message);
          }
          return result
          });
      },
      refetchOnWindowFocus: false,
    });
  }